import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormSelect, FormTextarea, SectionHeader } from '../../form';

const ClearingHouse: React.FC<any> = ({ formik }) => {
  const { t } = useTranslation();

  return (
    <SectionHeader
      title={t('prechecks.achClearingHouse')}
      icon={
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
      }
      iconBgColor="bg-blue-100"
      iconTextColor="text-blue-600"
      titleColor="text-blue-600"
    >
      <FormField
        id="chPayee"
        name="chPayee"
        label={t('prechecks.payeeNameBankAccount')}
        type="text"
        value={formik.values.chPayee}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.chPayee}
        touched={formik.touched.chPayee}
      />

      <FormField
        id="chClient"
        name="chClient"
        label={t('prechecks.clientNameProcessingStatement')}
        type="text"
        value={formik.values.chClient}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.chClient}
        touched={formik.touched.chClient}
      />

      <FormField
        id="chCustEmail"
        name="chCustEmail"
        label={t('prechecks.customerServiceEmail')}
        type="email"
        value={formik.values.chCustEmail}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.chCustEmail}
        touched={formik.touched.chCustEmail}
      />

      <FormTextarea
        id="chMktDesc"
        name="chMktDesc"
        label={t('prechecks.describeProductServiceMarketing')}
        value={formik.values.chMktDesc}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.chMktDesc}
        touched={formik.touched.chMktDesc}
        rows={4}
      />

      <FormTextarea
        id="chCompHandling"
        name="chCompHandling"
        label={t('prechecks.explainCustomerServiceComplaintHandling')}
        value={formik.values.chCompHandling}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.chCompHandling}
        touched={formik.touched.chCompHandling}
        rows={4}
      />

      <FormSelect
        id="chRefundPol"
        name="chRefundPol"
        label={t('prechecks.doYouHaveRefundPolicy')}
        value={formik.values.chRefundPol}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        options={[
          { value: 'no', label: t('common.no') },
          { value: 'yes', label: t('common.yes') },
        ]}
        error={formik.errors.chRefundPol}
        touched={formik.touched.chRefundPol}
      />

      <FormField
        id="chAchProvider"
        name="chAchProvider"
        label={t('prechecks.workingWithAnotherACHProvider')}
        type="text"
        value={formik.values.chAchProvider}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.chAchProvider}
        touched={formik.touched.chAchProvider}
      />

      <div className="border-t border-slate-200 pt-6 mt-6">
        <h4 className="text-lg font-semibold text-slate-700 mb-4">{t('prechecks.customerServiceManager')}</h4>

        <FormField
          id="chAchName"
          name="chAchName"
          label={t('prechecks.name')}
          type="text"
          value={formik.values.chAchName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chAchName}
          touched={formik.touched.chAchName}
        />

        <FormField
          id="chAchPhone"
          name="chAchPhone"
          label={t('prechecks.phoneNumber')}
          type="tel"
          value={formik.values.chAchPhone}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chAchPhone}
          touched={formik.touched.chAchPhone}
          className="mt-6"
        />

        <FormField
          id="chAchEmail"
          name="chAchEmail"
          label={t('prechecks.email')}
          type="email"
          value={formik.values.chAchEmail}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chAchEmail}
          touched={formik.touched.chAchEmail}
          className="mt-6"
        />
      </div>

      <div className="border-t border-slate-200 pt-6 mt-6">
        <h4 className="text-lg font-semibold text-slate-700 mb-4">{t('prechecks.transactionInformation')}</h4>

        <FormField
          id="chHighTxAmt"
          name="chHighTxAmt"
          label={t('prechecks.highestTransactionAmount')}
          type="text"
          value={formik.values.chHighTxAmt}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chHighTxAmt}
          touched={formik.touched.chHighTxAmt}
        />

        <FormField
          id="chLowTxAmt"
          name="chLowTxAmt"
          label={t('prechecks.lowestTransactionAmount')}
          type="text"
          value={formik.values.chLowTxAmt}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chLowTxAmt}
          touched={formik.touched.chLowTxAmt}
          className="mt-6"
        />

        <FormField
          id="chAvgTxAmt"
          name="chAvgTxAmt"
          label={t('prechecks.averageTransactionAmount')}
          type="text"
          value={formik.values.chAvgTxAmt}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chAvgTxAmt}
          touched={formik.touched.chAvgTxAmt}
          className="mt-6"
        />

        <FormField
          id="chMonthVol"
          name="chMonthVol"
          label={t('prechecks.monthlyVolumeEstimate')}
          type="text"
          value={formik.values.chMonthVol}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chMonthVol}
          touched={formik.touched.chMonthVol}
          className="mt-6"
        />

        <FormField
          id="chMonthTxCount"
          name="chMonthTxCount"
          label={t('prechecks.estimatedMonthlyNumberOfTransactions')}
          type="text"
          value={formik.values.chMonthTxCount}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.chMonthTxCount}
          touched={formik.touched.chMonthTxCount}
          className="mt-6"
        />
      </div>
    </SectionHeader>
  );
};

export default ClearingHouse;
